import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import './CheckEmail.scss';
import Logo2 from '../../../components/Logo/Logo2';


const Page404 = ({ type = '' }) => {
    document.title = 'Page Not Found | DB Design';

    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();


    // const handleSignUpClick = (event) => {
    //     event.preventDefault();
    //     setTimeout(() => { history.push('/sign-up'); }, 100);
    // };

    return (
        <div className="check-email-box">
            <Logo2 />
            <div className='check-email'>

                <div className="check-email-title not-found">404</div>

                <div className='check-email-text-wrap'>
                    {/* <p className="check-email-text verified">Page not found.</p> */}
                    <p className={`check-email-text ${type === 'diagram' ? 'not-found-diagram' : ''}`}>{type === 'diagram' ? "You don't have access to this diagram or it may no longer exist." : "Page not found."}</p>
                </div>

                <a href="/diagrams" className="check-email-action not-found">
                    <span>Back home</span>
                </a>

            </div>
        </div >
    );
};

export default Page404;
